export const Links = {
    ESERUYANIK_API: 'https://eseruyanik.com/api/',
    LOCAL_API: 'https://127.0.0.1:8000/'
}
export default Links;